export default class HttpApiCallError extends Error {

  constructor(data, message, statusCode) {

    super(message);

    this.data = data;
    this.message = message;
    this.statusCode = statusCode;

    this.stack = (new Error(message)).stack;
    this.name = 'HttpApiCallError';

  }

}



/** WEBPACK FOOTER **
 ** ./src/errors/HttpApiCallError.js
 **/